export enum BannerEnum {
  GREApplication = 'GRE',
  BannerEnabled = 'Y',
  BannerDisabled = 'N'
}
